import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {CommonGroupProps} from '../../type';

export default function EventBannerGrid({children}: CommonGroupProps) {
  return (
    // 원래 Groups에서 공통으로 좌우 11px 패딩을 잡아줘야하는데, 모바일 배너에서는 캐러셀 내부에 패딩을 잡아줘야해서 따로 처리합니다.
    <Grid cols={1} foldableCols={2} gapPx={4} className="px-11pxr">
      {children}
    </Grid>
  );
}
